import PossoDropdownToggle from "./PossoDropdownToggle";
import { Dropdown } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import useIsMobile from "./hooks/useIsMobile";

function PossoDropdown(props) {
    const navigate = useNavigate();
    const isMobile = useIsMobile();
    const organizationFeatures = props.organizationFeatures || [];
    const hasInterviews = organizationFeatures.includes('interviews');
    const hasAssessments = organizationFeatures.includes('assessments') || organizationFeatures.includes('competency_interview');

    function logOut(redirect_url) {
        const requestOptions = {
            method: 'POST',
            credentials: 'include'
        };
        fetch(`${process.env.REACT_APP_API_URL}/session_logout`, requestOptions)
            .then(res => res.json())
            .then(
                (result) => {
                    window.location.href = redirect_url
                    return false;
                }
            )
    }

    function goAspirantHome() {
        navigate('/aspirant')
    }

    // function goOrganizationHome() {
    //     navigate('/organization')
    // }

    function goProfile() {
        navigate('/aspirant_profile')
    }

    function goScheduleInterview() {
        navigate('/aspirant_select_company')
    }

    function goBrowseInterviews() {
        navigate('/aspirant_results')
    }

    function goOrgHome() {
        navigate('/organization')
    }

    function goManagejobs() {
        navigate('/organization/jobs')
    }

    function goManageCandidates() {
        navigate('/organization/candidates')
    }

    function goOrgSettings() {
        navigate('/organization/settings')
    }
    
    function goAllInterviews() {
        navigate('/organization/interviews')
    }
    function goAdminDashboard() {
        navigate('/admin/dashboard')
    }

    function goCompetencyEvaluation() {
        navigate('/organization/jobs?job_type=competency')
    }

    function goAssessmentResults() {
        navigate('/organization/competency-results')
    }

    return <>
        {isMobile && props.appHeader === false ?
            props.userType === 'orgUser'
                ?
                <>
                    <Link id="menuorgdashlnk" className="nav-link me-lg-e p-1" onClick={goOrgHome}>Dashboard</Link>
                    {hasInterviews && (
                        <Link id="menumgjoblnk" className="nav-link me-lg-e p-1" onClick={goManagejobs}>Manage Jobs</Link>
                    )}
                    {hasAssessments && (
                        <Link id="menuorgcompetencylnk" className="nav-link me-lg-e p-1" onClick={goCompetencyEvaluation}>Manage Assessments</Link>
                    )}
                    <Link id="menumgcandlnk" className="nav-link me-lg-e p-1" onClick={goManageCandidates}>Manage Candidates</Link>
                    <Link id="menuorgsetting" className="nav-link me-lg-e p-1" onClick={goOrgSettings}>Settings</Link>
                    {hasInterviews && (
                        <Link id="menuallinterviews" className="nav-link me-lg-e p-1" onClick={goAllInterviews}>All Interview Results</Link>
                    )}
                    {hasAssessments && (
                        <Link id="menuallassessments" className="nav-link me-lg-e p-1" onClick={goAssessmentResults}>All Assessment Results</Link>
                    )}
                    {hasAssessments && (
                        <Link id="menuassessmentinsights" className="nav-link me-lg-e p-1" onClick={() => navigate('/organization/assessment-insights')}>Assessment Insights</Link>
                    )}

                    <hr className="dropdown-divider" />
                    <Link id="menuorgsignoutlnk" className="nav-link me-lg-e p-1" onClick={() => logOut(`${process.env.REACT_APP_MARKETING_URL}`)}>Sign out</Link>
                </>
                : props.userType === 'adminUser' ?
                    <>
                        <Link id="menuaspdashlnk" className="nav-link me-lg-e p-1" onClick={goAdminDashboard}>Dashboard</Link>
                    </>
                    :
                    <>
                        <Link id="menuaspdashlnk" className="nav-link me-lg-e p-1" onClick={goAspirantHome}>Dashboard</Link>
                        <Link id="menuaspschlnk" className="nav-link me-lg-e p-1" onClick={goScheduleInterview}>Take Assessment</Link>
                        <Link id="menuaspbrowselnk" className="nav-link me-lg-e p-1" onClick={goBrowseInterviews}>My Assessments</Link>
                        <Link id="menuaspprofilelnk" className="nav-link me-lg-e p-1" onClick={goProfile}>Account settings</Link>
                        <hr className="dropdown-divider" />
                        <Link id="menuaspsignoutlnk" className="nav-link me-lg-e p-1" onClick={() => logOut(`${process.env.REACT_APP_MARKETING_URL}`)}>Sign out</Link>
                    </>
            :
            <Dropdown align="end" className="ms-auto">
                <PossoDropdownToggle userLabel={props.userLabel} picture={props.picture} />
                {
                    props.userType === 'orgUser'
                        ?

                        <Dropdown.Menu variant='light'>
                            <Dropdown.Item id="menuorgdashlnk" onClick={goOrgHome}>Dashboard</Dropdown.Item>
                            {hasInterviews && (
                                <Dropdown.Item id="menumgjoblnk" onClick={goManagejobs}>Manage Jobs</Dropdown.Item>
                            )}
                            {hasAssessments && (
                                <Dropdown.Item id="menuorgcompetencylnk" onClick={goCompetencyEvaluation}>Manage Assessments</Dropdown.Item>
                            )}
                            <Dropdown.Item id="menumgcandlnk" onClick={goManageCandidates}>Manage Candidates</Dropdown.Item>
                            <Dropdown.Item id="menuorgsetting" onClick={goOrgSettings}>Settings</Dropdown.Item>
                            {hasInterviews && (
                                <Dropdown.Item id="menuallinterviews" onClick={goAllInterviews}>All Interview Results</Dropdown.Item>
                            )}
                            {hasAssessments && (
                                <Dropdown.Item id="menuallassessments" onClick={goAssessmentResults}>All Assessment Results</Dropdown.Item>
                            )}
                            {hasAssessments && (
                                <Dropdown.Item id="menuassessmentinsights" onClick={() => navigate('/organization/assessment-insights')}>Assessment Insights</Dropdown.Item>
                            )}

                            <hr className="dropdown-divider" />
                            <Dropdown.Item id="menuorgsignoutlnk" onClick={() => logOut(`${process.env.REACT_APP_MARKETING_URL}`)}>Sign out</Dropdown.Item>
                        </Dropdown.Menu>

                        : props.userType === 'adminUser' ?
                            <Dropdown.Menu variant='light'>
                                <Dropdown.Item id="menuaspdashlnk" onClick={goAdminDashboard}>Dashboard</Dropdown.Item>
                                <hr className="dropdown-divider" />
                                <Dropdown.Item id="menuaspsignoutlnk" onClick={() => logOut('/admin')}>Sign out</Dropdown.Item>
                            </Dropdown.Menu>
                            :
                            <Dropdown.Menu variant='light'>
                                <Dropdown.Item id="menuaspdashlnk" onClick={goAspirantHome}>Dashboard</Dropdown.Item>
                                <Dropdown.Item id="menuaspschlnk" onClick={goScheduleInterview}>Take Assessment</Dropdown.Item>
                                <Dropdown.Item id="menuaspbrowselnk" onClick={goBrowseInterviews}>My Assessments</Dropdown.Item>
                                <Dropdown.Item id="menuaspprofilelnk" onClick={goProfile}>Account settings</Dropdown.Item>
                                <hr className="dropdown-divider" />
                                <Dropdown.Item id="menuaspsignoutlnk" onClick={() => logOut(`${process.env.REACT_APP_MARKETING_URL}`)}>Sign out</Dropdown.Item>
                            </Dropdown.Menu>
                }
            </Dropdown>
        }
    </>
}

export default PossoDropdown;